import * as styleConstants from "@affinity/constants/StyleConstants";
import * as styleHelpers from "@affinity/constants/StyleHelpers";
import Clickable, { ClickableLinkProps } from '@insite/mobius/Clickable'
import Icon from "@insite/mobius/Icon";
import React from 'react'
import { css, FlattenSimpleInterpolation } from 'styled-components';

const ButtonLinkCss = css`   
    display: flex;
    width: fit-content;
    padding: ${styleHelpers.rem(9)} ${styleHelpers.rem(20)};

    background-color: ${styleConstants.colours.green};
    border: ${styleHelpers.rem(2)} solid ${styleConstants.colours.green};
    border-bottom: ${styleHelpers.rem(2)} solid ${styleConstants.colours.darkBlue};

    font-weight: 700;
    font-size: ${styleHelpers.rem(18)};
    line-height: 1.33;

    color: ${styleConstants.colours.white};

    transition: all 200ms ease-in-out;
    &:hover, &:focus{
        color: ${styleConstants.colours.green};
        border: ${styleHelpers.rem(2)} solid ${styleConstants.colours.green};
        background-color: ${styleConstants.colours.white};
    }
    span { 
        color: inherit;
    }
`;

export type ButtonLinkProps = {
    href: string;
    css?: FlattenSimpleInterpolation;
    icon?: {
        src: React.ComponentType | string;
        position: "right" | "left";
    };
}

const ButtonLink: React.FC<ButtonLinkProps & ClickableLinkProps> = props => {
    const style = css`
        ${ButtonLinkCss}
        ${props.css}
    `;

    const position = props.icon?.position;
    const src = props.icon?.src;

    return (
        // need to set button as will default to submit button in forms
        <Clickable type={props.href ? "" : "button"} {...props} href={props.href} css={style}>
            {position === "left" && <Icon src={src}/>}
            {props.children}
            {position === "right" && <Icon src={src}/>}
        </Clickable>
    )
}

export default ButtonLink